import './polyfills';
import { idtApi } from './idt/idtApi';
import { scenePlugins, variablePlugins } from '@gift/common/helpers/_registry';
import { basicWebsitePlugin } from '@gift/basic-scene-website/basicWebsitePlugin';
import { textWebsitePlugin } from '@gift/text-website/textWebsitePlugin';
import { svgWebsitePlugin } from '@gift/svg-website/svgWebsitePlugin';
import { engravingWebsitePlugin } from '@gift/engraving-website/engravingWebsitePlugin';
import { paintablesWebsitePlugin } from '@gift/paintables-website/paintablesWebsitePlugin';
import { colorAttributeWebsitePlugin } from '@gift/attributes-color-website/colorAttributeWebsitePlugin';
import { sizeAttributeWebsitePlugin } from '@gift/attributes-size-website/sizeAttributeWebsitePlugin';

/**
 * Non-module style rules should always be the final import.
 * This way any overrides to `.idt-active` for example can be done at the component level,
 * and made slightly more specific should this be desirable.
 */
import './preflight.scss';
import './global.scss';

scenePlugins.use(basicWebsitePlugin);
variablePlugins.use(textWebsitePlugin);
variablePlugins.use(svgWebsitePlugin);
variablePlugins.use(engravingWebsitePlugin);
variablePlugins.use(paintablesWebsitePlugin);
variablePlugins.use(colorAttributeWebsitePlugin);
variablePlugins.use(sizeAttributeWebsitePlugin);

if (typeof window.__idt_hook === 'function') {
    window.__idt_hook(idtApi);
} else {
    window.IDT = idtApi;
}
